define('lib/theme/ThemeSettings',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    var ThemeSettings = Marionette.Object.extend({

        _theme: null,
        _userOptions: null,

        initialize: function (options, theme, userOptions) {
            this._theme = theme;
            this._userOptions = userOptions;
        },

        getThemeName: function () {
            return this._theme;
        },

        getOptions: function () {
            return this.options;
        },

        getThemeOptions: function () {
            var skipSubString = ['image_original', 'image_preview', 'file_name', 'image_mode', 'image_position'];
            var result = {};
            _.each(this.options, function (value, key) {
                for (var i = 0; i < skipSubString.length; i++) {
                    if (key.indexOf(skipSubString[i]) !== -1) {
                        return;
                    }
                }
                result[key] = value;
            });

            // Because of recent changes to themes, we have to prevent issues for users with old variables widget codes
            if (this._userOptions) {
                if (this._userOptions.btn_color_1 === undefined && this.options.allow_new_theme_btn_color) {
                    result.btn_color_1 = false;
                }
            }

            return result;
        },

        setOptions: function (options) {
            _.extend(this.options, options);
            _.extend(this._userOptions, options);
        },

        resetOptions: function () {
            this.options = {};
            this._userOptions = {};
        }

    });

    ThemeSettings._instance = null;
    ThemeSettings.getInstance = function (options, theme, userOptions) {
        if (!ThemeSettings._instance) {
            ThemeSettings._instance = new ThemeSettings(options, theme, userOptions);
        }
        return ThemeSettings._instance;
    };

    return ThemeSettings;

});
